import { createContext, useState, useEffect } from 'react';

// Create the Auth context with default values
const AuthContext = createContext({
  user: null,
  login: () => {},
  logout: () => {},
  updateUser: () => {},
});

// Create the Auth Provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on component mount
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        
        if (token) {
          // Call API to get current user
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/me`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (response.ok) {
            const userData = await response.json();
            // Make sure merit is included in user data (will be added by backend)
            setUser(userData);
          } else {
            // If API call fails, clear token
            localStorage.removeItem('token');
          }
        }
      } catch (error) {
        console.error('Authentication check failed:', error);
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    };
    
    checkAuth();
  }, []);

  const login = (userData, token) => {
    // userData should include merit from the login response
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const updateUser = (userData) => {
  setUser(prev => ({
    ...prev,
    ...userData,
    // Ensure we're preserving the profilePictureUrl if it wasn't provided in the update
    profilePictureUrl: userData.profilePictureUrl ?? prev?.profilePictureUrl
  }));
};

  // Add a specific function to update merit (optional, for direct merit updates)
  const updateMerit = (newMerit) => {
    if (user) {
      setUser((prevUser) => ({
        ...prevUser,
        merit: newMerit
      }));
    }
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      logout, 
      updateUser, 
      updateMerit, // Add the new merit update function
      loading 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;